import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 16px;
    padding: 24px;
  `}
`;

export const Icon = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    font-size: 1.8rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver80};
    line-height: 1;
    margin-bottom: 8px;
  `}
`;

export const Text = styled.div`
  ${({ theme }) => css`
    > * {
      font-size: 1.6rem;
      color: ${theme.colors.neutralSilver70};
      line-height: 1.6;
      margin: 0;
    }
  `}
`;
